import React from "react";
import ReactDOM from "react-dom/client";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { BrowserRouter } from "react-router-dom";

import QueryClientContext from "./context/QueryClientContext";
import ToastProvider from "./context/ToastContext";
import AuthProvider from "./context/AuthContext";

import ptBR from "date-fns/locale/pt-BR";
import App from "./App";
import ScrollToTop from "./components/ScrollToTop";

registerLocale("ptBR", ptBR);
setDefaultLocale("ptBR");

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
	<BrowserRouter basename={process.env.PUBLIC_URL}>
		<ToastProvider>
			<AuthProvider>
				<QueryClientContext>
					<ScrollToTop />
					<App />
				</QueryClientContext>
			</AuthProvider>
		</ToastProvider>
	</BrowserRouter>
);
